import "./App.css";
import Home from "./Pages/Home/Home";
import Presale from "./Pages/Presale/Presale";
import { Routes, Route } from "react-router-dom";
import Footer from "./Components/Footer";
import Staking from "./Pages/Staking/Staking";
import Web3 from "web3";
import { useEffect, useState } from "react";
import NetworkChange from "./NetworkChange";
// import  CountdownTimer  from "./Components/CounterTimer";
const web3 = new Web3(
  Web3.givenProvider
    ? Web3.givenProvider
    : "https://data-seed-prebsc-1-s1.binance.org:8545/"
);
function App() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let chain = async () => {
      const chainid = await web3.eth.getChainId();
      if (chainid !== 97) {
        setOpen(true);
      }
    };
    chain();
  }, []);

  return (
    <div>
      <NetworkChange open={open} setOpen={setOpen} />
      {/* <CountdownTimer /> */}
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/presale" element={<Presale />}></Route>
        <Route path="/staking" element={<Staking />}></Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
